<template>
  <div class="tw-aside-tools-inner">
    <q-dialog v-model="visible" persistent position="right">
      <div class="card enhanced-card">
        <div class="card-header bg-gradient p-3">

          <div class="header-content">
            <div class="task-definition-container">

              <div class="task-definition-content">
                <div class="task-definition-title">
                  {{ `${$t('main.label.of')} ` }} {{ `${$t(`task.actions.${statusHistoryVariableSelected.taskDefinition}`)} ` }}
                </div>
              </div>
            </div>
            <q-btn 
              flat 
              round 
              dense 
              icon="close" 
              class="close-btn" 
              @click="closeStatusHistory"
              :ripple="false"
            />
          </div>
        </div>
          <q-table
              :rows="rows"
              :columns="columns"
              row-key="id"
              hide-pagination
              v-model:pagination="pagination"
              class="shadow-1 table table-sm bg-light mb-0 enhanced-table">
            <template v-slot:header="props">
              <q-tr :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                  <template v-if="col.name !== 'actions'">
                    <span class="label-column">{{ $t(col.label) }}</span>
                  </template>
                </q-th>
                <q-th auto-width />
              </q-tr>
            </template>

            <template v-slot:body="props">
              <q-tr :props="props">
                <q-td v-for="col in props.cols" :key="col.name" :props="props">
                  {{ col.value }}
                </q-td>
              </q-tr>
            </template>
          </q-table>
        </div>
    </q-dialog>
  </div>
</template>

<script lang="ts">
import store from "@/store";
import { Options, Vue } from "vue-class-component";
import LabelAndValue from "@/components/general/LabelAndValue.vue";
import {globalConfig ,getConfigurationEnv} from "@/utils";
import i18n from "@/i18n";

@Options({
  components: { LabelAndValue },
  watch: {
    "$store.state.orderModule.variablesVisible"(newValue) {
      this.visible = newValue;
    },
    async "$store.state.orderModule.statusHistoryVariableSelected"(newValue) {
      if (newValue) {
        const env = getConfigurationEnv();  
        // console.log('Configuration Env:', env);
        this.rows = [
          {"label":  i18n.global.t('task.historiesStep.headers.variables.orderReference'), "value": newValue.orderReference},
          {"label":  i18n.global.t('task.historiesStep.headers.variables.orderStatus'), "value": i18n.global.t(`order.picklist.status.${newValue.orderStatus}`)},
          {"label":  i18n.global.t('task.historiesStep.headers.variables.orderPhase'), "value": i18n.global.t(`task.actions.${newValue.taskDefinition}`)},
          {"label":  i18n.global.t('task.historiesStep.headers.variables.initialDeliveryDate'), "value": newValue.initialDeliveryDate},
          {"label":  i18n.global.t('task.historiesStep.headers.variables.provisionalDeliveryDate'), "value": newValue.provisionalDeliveryDate},
          {"label":  i18n.global.t('task.historiesStep.headers.variables.comment'), "value": newValue.comment}]

          if (env === 'GEMY') {
          this.rows.push({"label":  i18n.global.t('task.historiesStep.headers.variables.cancellationDate'), "value": newValue.orderItemCancellationDate});
        }
      } else {
        this.rows = []
      }
    },
  },
})
export default class StatusOrderHistory extends Vue {
  visible: boolean = false;
  rows: any = []

  pagination = {
    rowsPerPage: 20
  };

  closeStatusHistory() {
    store.dispatch("orderModule/setOrderVariablesVisible", false);
  }

  get columns() {
    return globalConfig.table_config.statusHistoryCols;
  }

  get statusHistoryVariableSelected() {
  
    return store.state.orderModule.statusHistoryVariableSelected;
  }

}
</script>
<style scoped>
.enhanced-card {
  border-radius: 12px;
  box-shadow: 0px 8px 25px rgba(0, 0, 0, 0.12);
  overflow: hidden;
}

.bg-gradient {
  background: linear-gradient(135deg, #3699FF 0%, #3699FF 100%);
  position: relative;
}

.bg-gradient::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
}

.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  z-index: 1;
}

.task-definition-container {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.task-icon-wrapper {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 12px;
  padding: 12px;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.3);
}

.task-icon {
  font-size: 24px;
  color: white;
}

.task-definition-content {
  flex: 1;
}

.task-definition-label {
  font-size: 12px;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.8);
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.task-definition-title {
  font-size: 15px;
  font-weight: 700;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  line-height: 1.2;
  margin-left: 4%;
}

.close-btn {
  color: white;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
}

.close-btn .q-icon {
  font-size: 20px;
}

.label-column {
  font-weight: bold;
  font-size: 14px;
  color: #333;
}

.highlight-status {
  color: #28a745;
  font-weight: 600;
}

.enhanced-table tbody tr:hover {
  background-color: #f9f9f9;
  transition: background-color 0.2s ease;
}

.enhanced-table tbody tr:nth-child(even) {
  background-color: #f7f7f7;
}

.card-body {
  padding: 20px;
}

/* Animation for when dialog opens */
.q-dialog__inner {
  animation: slideInRight 0.3s ease-out;
}

@keyframes slideInRight {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Responsive design */
@media (max-width: 768px) {
  .task-definition-container {
    gap: 12px;
  }
  
  .task-icon-wrapper {
    padding: 8px;
  }
  
  .task-icon {
    font-size: 20px;
  }
  
  .task-definition-title {
    font-size: 16px;
  }
  
  .task-definition-label {
    font-size: 11px;
  }
  
  .card-body {
    padding: 15px;
  }
  
  .close-btn .q-icon {
    font-size: 18px;
  }
}

@media (max-width: 480px) {
  .task-definition-container {
    gap: 8px;
  }
  
  .task-definition-title {
    font-size: 14px;
  }
  
  .card-body {
    padding: 10px;
  }
}
</style>
